import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

// TODO: Update experimental grid copy to latest (app/evaluation/grid or app/coaching/insight/winning-percentage/grid)
import { ExperimentalNgGridModule } from './experimental.ng.grid';
import { ReusableGridSortComponent } from './reusable-grid-sort/reusable-grid-sort.component';
import { ReusableGridTextComponent } from './reusable-grid-text/reusable-grid-text.component';
import { ReusableGridComponent } from './reusable-grid.component';

@NgModule({
    imports: [
        CommonModule,
        CmpsTooltipModule,
        CmpsButtonModule,
        CmpsIconModule,
        ExperimentalNgGridModule,
    ],
    declarations: [
        ReusableGridSortComponent,
        ReusableGridTextComponent,
        ReusableGridComponent,
    ],
    exports: [
        ReusableGridSortComponent,
        ReusableGridTextComponent,
        ReusableGridComponent,
    ],
})
export class ReusableGridModule {}
